import React from 'react'
import styled, { css } from 'styled-components'

import {
    KioskContent,
    KioskHeader,
    RecipeItem,
    RecipeTitle,
    RecipePoints,
    RecipePrice,
    RecipeLabels,
    RecipeLabel,
    EnergyKCal,
} from '../Kiosk/style'
import LabelIcons from '../LabelIcons/LabelIcons'

const PrintKioskHeader = styled(KioskHeader)`
    zoom: ${props => props.zoom};
    position: relative;
    height: ${({ useCommercialName }) => (useCommercialName ? 30 : 70)}px;
    img {
        height: ${props => (props.fullSize ? 'auto' : '60px')};
        width: ${props => (props.fullSize ? '250px' : 'auto')};
        object-fit: contain;
        position: relative;
        background-color: #fff;
        left: calc(50% - 75px);
        top: 10px;

        ${props =>
            props.fullSize &&
            css`
                left: calc(50% - 125px);
                position: relative;
            `}
    }
    h3 {
        text-align: center;
        width: fit-content;
        padding: 5px;
        margin: auto;
        color: ${_ => _.theme.header_background};
        margin-bottom: 15px !important;
        &:after {
            content: '';
            height: 2px;
            background-color: ${_ => _.theme.header_background};
            width: 100%;
            width: 80%;
            position: absolute;
            left: 10%;
            bottom: -2px;
        }
    }
`

const PrintKioskContent = styled.div`
    ${props =>
        props.isMonoKiosk &&
        css`
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: start;
            margin-top: 1cm;
        `}
`

const PrintMonoKioskTitle = styled.h1`
    font-size: 4em;
    font-weight: 400;
    color: #000;
    text-align: center;

    font-family: Angelique;
    letter-spacing: 0;
`

const PrintLogoLine = styled.span`
    background-color: ${_ => _.theme.print_kiosk_border_color || '#3c3c3b'};
    position: absolute;
    top: 50%;
    left: 0;
    height: ${_ => _.theme.print_kiosk_border_width || '2px'};
    width: 100%;
`

const PrintRecipeItem = styled(RecipeItem)`
    ${props =>
        !props.fullSize &&
        css`
            grid-template-columns: 1fr auto 1.2cm;
        `}
    border-bottom: none;
    grid-gap: 5px 10px;
    zoom: ${props => props.zoom};

    margin: 0;

    ${props =>
        props.centered &&
        css`
            display: block;
            div {
                text-align: center;
            }
        `}
    ${props =>
        props.isHighlighted &&
        css`
            margin-top: 2em;
            margin-bottom: 2em;
            border: 1px solid
                ${_ => _.theme.print_kiosk_border_color || '#3c3c3b'};
            h2 {
                color: ${props => props.theme.recipe_price_background};
                grid-column: 1/4;
            }
        `}

    ${props =>
        props.customStyle &&
        props.customStyle === 'produit_neo' &&
        css`
            margin-top: 2em;
            border: 2px solid #003f45;
            ${RecipePoints} {
                & > span {
                    color: white;
                }
            }
            ${RecipePrice} {
                & > span {
                    color: #003f45;
                    background-color: white;
                    border-color: #003f45;
                }
            }
        `}
`

const PrintRecipeTitle = styled(RecipeTitle)`
    position: relative;
    color: #3c3c3b;
    font-weight: 600;
    grid-column: 1;
`

const PrintRecipeLabel = styled.img``

const StyledInlineInput = styled.input`
    color: #3c3c3b;
    font-size: 1.3em;
    font-weight: 500;
    border: none;
    outline: none;
    appearance: none;
    text-align: ${props => (props.centered ? 'center' : 'inherit')};

    :hover,
    :focus {
        color: ${props => props.theme.recipe_price_background};
    }

    font-family: inherit;
    width: 100%;
`

const StyledEditableRecipeTitle = styled.div`
    position: relative;
    grid-column: 1;
    img {
        display: ${props => (props.editMode ? 'block' : 'none')};
        position: absolute;
        top: 0;
        left: -26px;
        height: 20px;
        fill: ${props => props.theme.recipe_price_background};
    }

    :hover {
        img {
            display: block !important;
        }
    }
`

class EditableRecipeTitle extends React.Component {
    state = {
        value: this.props.value,
        editMode: false,
    }

    handleChange = e => this.setState({ value: e.target.value })

    handleFocus = e => e.target.select()

    toogleEditMode = () => {
        this.setState({ editMode: !this.state.editMode }, () => {
            this.inputRef && this.inputRef.focus()
            if (!this.state.editMode) {
                this.props.handleEditItem(this.props.itemIndex)
            }
        })
    }

    render() {
        return (
            <StyledEditableRecipeTitle
                onClick={this.toogleEditMode}
                editMode={this.state.editMode}
            >
                {this.state.editMode ? (
                    <StyledInlineInput
                        ref={r => (this.inputRef = r)}
                        type="text"
                        value={this.state.value}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.toogleEditMode}
                    />
                ) : (
                    <PrintRecipeTitle>
                        {this.state.value}
                        {/* <PrintRecipeLabel
                            src={`img/labels/${this.props.label}.png`}
                        /> */}
                    </PrintRecipeTitle>
                )}
                <img src="img/edit.svg" />
            </StyledEditableRecipeTitle>
        )
    }
}

class printKiosk extends React.Component {
    state = {
        editedItems: [],
    }

    render() {
        const {
            dataSource,
            isMonoKiosk,
            name,
            concept,
            kioskPicture,
            items,
            monoKioskTitle,
            useCommercialName,
            hideMenuPrice,
            hideRecipePoints,
            hideEnergyKcal,
            showEnergyKcalByPortion,
            hideLabels,
            hideIntolerences,
            zoom,
            isAdmin,
            centered,
            currency,
            showDate,
        } = this.props

        const { editedItems } = this.state

        items.map(item => {
            if (item.price_currency && !!item.price_currency) {
                const priceRegex = /(\d+)[,|.](\d+)(.*)/
                const priceMatches = priceRegex.exec(item.price_currency)
                if (priceMatches) {
                    item.priceInt = priceMatches[1]
                    const decimals =
                        parseInt(priceMatches[2]) !== 0 ? priceMatches[2] : ''
                    item.priceSup = priceMatches[3].trim() + decimals
                }
            }

            // if (!!item.price_point) {
            //     item.price_point = item.price_point.replace(/\D/g, '')
            // }

            if (item.price) {
                const priceArray = item.price.toString().split('.')
                item.priceInt =
                    priceArray[0].toString() + item.currency || currency
                item.priceSup = priceArray[1]
                    ? priceArray[1].length > 1
                        ? priceArray[1]
                        : `${priceArray[1]}0`
                    : ''
            }
            return item
        })

        const handleEditItem = item => {
            this.setState({ editedItems: [item, ...editedItems] })
        }

        return (
            <KioskContent
                isMonoKiosk={isMonoKiosk}
                style={{
                    padding: isMonoKiosk ? '0' : '.5em',
                    height: isMonoKiosk ? '100%' : 'auto',
                }}
            >
                <PrintKioskHeader
                    zoom={!isMonoKiosk && zoom}
                    fullSize={isMonoKiosk}
                    useCommercialName={useCommercialName}
                >
                    {!isMonoKiosk && !useCommercialName && <PrintLogoLine />}
                    {useCommercialName ? (
                        <h3>{name}</h3>
                    ) : (
                        <img
                            src={`img/concept/${concept}/kiosk/${kioskPicture ||
                                name}/menu_eco.png`}
                            alt={name}
                        />
                    )}
                </PrintKioskHeader>
                {isMonoKiosk && monoKioskTitle && (
                    <PrintMonoKioskTitle>{monoKioskTitle}</PrintMonoKioskTitle>
                )}
                <PrintKioskContent isMonoKiosk={isMonoKiosk}>
                    {items.map(
                        (item, index) =>
                            item.menu_board_label && (
                                <PrintRecipeItem
                                    key={index}
                                    fullSize={isMonoKiosk}
                                    zoom={zoom}
                                    centered={centered}
                                    isHighlighted={
                                        isMonoKiosk && item.produit_du_jour
                                    }
                                    customStyle={item.produit_du_jour || ''}
                                >
                                    {isMonoKiosk &&
                                    item.produit_du_jour &&
                                    item.produit_du_jour !== 'produit_neo' ? (
                                        <h2>{item.produit_du_jour}</h2>
                                    ) : null}
                                    {/* {isAdmin ? (
                                        <PrintRecipeTitle>
                                            {item.menu_board_label}
                                        </PrintRecipeTitle>
                                    ) : (
                                        <>
                                            <EditableRecipeTitle
                                                value={item.menu_board_label}
                                                zoom={zoom}
                                                handleEditItem={handleEditItem}
                                                itemIndex={index}
                                                centered={centered}
                                                label={item.label}
                                            />
                                        </>
                                    )} */}
                                    {item.produit_du_jour === 'produit_neo' && (
                                        <img
                                            src={`img/neo.jpg`}
                                            style={{
                                                height: '46px',
                                                marginTop: '-31px',
                                            }}
                                        />
                                    )}
                                    <PrintRecipeTitle>
                                        <span style={{ marginRight: '.6em' }}>
                                            {item.menu_board_label}
                                        </span>
                                        {!hideLabels && item.label && (
                                            <RecipeLabel
                                                src={`img/labels/${item.label}.png`}
                                                onError={i => (i.target.style.display = 'none')}
                                            />
                                        )}
                                        {!hideLabels &&
                                            item.caracteristique_produit && (
                                                <RecipeLabel
                                                    src={`img/labels/${item.caracteristique_produit}.png`}
                                                    onError={i => (i.target.style.display = 'none')}
                                                />
                                            )}
                                    </PrintRecipeTitle>
                                    <>
                                        {!hideRecipePoints &&
                                        !!item.price_point ? (
                                            <RecipePoints mode="print" endPosition={hideMenuPrice}>
                                                <span>{item.price_point}</span>
                                            </RecipePoints>
                                        ) : null}

                                        {!hideMenuPrice && !!item.priceInt ? (
                                            <RecipePrice mode="print">
                                                <span>
                                                    {item.priceInt}
                                                    <span>{item.priceSup}</span>
                                                </span>
                                            </RecipePrice>
                                        ) : null}
                                    </>

                                    {!hideIntolerences &&
                                        editedItems.indexOf(index) === -1 && (
                                            <RecipeLabels>
                                                <LabelIcons
                                                    item={item}
                                                    size="24px"
                                                    dataSource={dataSource}
                                                />
                                            </RecipeLabels>
                                        )}

                                    {!hideEnergyKcal && (
                                        showEnergyKcalByPortion ? (
                                            !!item.energyKCalByPortion && (
                                                <EnergyKCal>
                                                    <span>{item.energyKCalByPortion}</span>
                                                </EnergyKCal>
                                            )
                                        ) : (
                                            !!item.energyKCal && (
                                                <EnergyKCal>
                                                    <span>
                                                        {item.energyKCal}
                                                        <sup style={{ marginLeft: '0.2em', fontSize: '0.6em' }}>100g</sup>
                                                    </span>
                                                </EnergyKCal>
                                            )
                                        )
                                    )}
                                </PrintRecipeItem>
                            )
                    )}
                </PrintKioskContent>
            </KioskContent>
        )
    }
}
export default printKiosk
